import { FC } from 'react';

import { Link, usePage } from '@inertiajs/react';
import { Dot } from 'lucide-react';

import { BreadcrumbsService } from '../../services/BreadcrumbsService';
import { Expansion, OverviewProduct, ProductType, Universe } from '../../types';
import { BreadCrumbInput } from '../../types/breadcrumbs';

type PageProps = {
    product: OverviewProduct;
    currentUniverse: Universe;
    currentProductType: ProductType;
    currentExpansion: Expansion;
};

export const ProductBreadcrumbs: FC = () => {
    const {
        product: currentProduct,
        currentUniverse,
        currentProductType,
        currentExpansion,
    } = usePage<PageProps>().props;

    const input: BreadCrumbInput[] = [
        {
            type: 'universe',
            value: currentUniverse,
        },
        {
            type: 'productType',
            value: currentProductType,
        },
        {
            type: 'expansion',
            value: currentExpansion ?? null,
        },
        {
            type: 'product',
            value: currentProduct,
        },
    ];

    const breadcrumbs = BreadcrumbsService.generateBreadcrumbs(
        input,
        currentProductType,
    );

    return (
        <div className="flex items-center gap-1">
            {breadcrumbs.map((breadcrumb, i) => (
                <div
                    key={breadcrumb.name}
                    className="flex items-center gap-0.5"
                >
                    <Link
                        className="text-sm text-muted-foreground hover:text-foreground"
                        key={breadcrumb.name}
                        href={breadcrumb.url}
                    >
                        {breadcrumb.name}
                    </Link>
                    {i !== breadcrumbs.length - 1 && <Dot />}
                </div>
            ))}
        </div>
    );
};
